const localizers = {
  'loading.msg': () => `Laster inn...`,
  'SASServer.genericError.msg': () => `Tjeneren kan ikke nås.`,
  'SASReport.genericError.msg': () => `Kan ikke laste inn den valgte rapporten.`,
  'SASReportImage.genericError.msg': () => `Rapportbildet kunne ikke lastes inn.`,
  'SASReportImage.imageNotSupported.msg': () => `Bildene støttes ikke for denne rapportinnholdstypen.`,
}
export default localizers;
